// Copyright (c) 2017 Deere & Company

import amountOfUseItemToUpdate from './amount-of-use-item-to-update';
import amountOfUseLength from './amount-of-use-length';
import amountOfUseModal from './amount-of-use-modal';
import amountOfUseRequestSearchFilters from './amount-of-use-search-filters';
import amountOfUseView from './amount-of-use-updates';
import auditCount from './audit-count';
import busyCounter from '../../../shared/reducers/busy-counter';
import closingAccountChanges from './closing-account';
import closingAccountIndex from './closing-account-index';
import closingAccountLength from './closing-account-length';
import closingAccountSearchFilters from './closing-account-search-filters';
import {combineReducers} from 'redux';
import duplicatePinPlateLength from './duplicate-pin-plate-length';
import duplicatePinPlateSearchFilters from './duplicate-pin-plate-search-filters';
import duplicatePinPlateView from './duplicate-pin-plate';
import facetFilterText from './facet-filter-text';
import filteredTerritories from './filtered-territories';
import initialLoad from './initial-load';
import laborRateChanges from './labor-rate-changes';
import laborRateChangesLength from './labor-rate-changes-length';
import laborRateChangesSearchFilters from './labor-rate-changes-search-filters';
import machineStatusItemToUpdate from './machine-status-item-to-update';
import machineStatusModal from './machine-status-modal';
import machineStatusSearchFilters from './machine-status-search-filters';
import machineStatusUpdates from './machine-status-updates';
import pipCodeRequestItemToUpdate from './pip-code-request-item-to-update';
import pipCodeRequestModal from './pip-code-request-modal';
import pipCodeRequestSearchFilters from './pip-code-request-search-filters';
import pipCodeRequests from './pip-code-requests';
import reportsAccordion from './reports-accordion';
import searchByDropDown from './search-by-dropdown';
import searchQueryString from './search-query-string';
import selectedSpaLevels from './selected-spa-levels';
import specialAllowanceClaims from './special-allowance-claims';
import specialAllowanceClaimsSearchFilters from './spa-claims-search-filters';
import tcsmSettings from './tcsm-settings';
import wipFacets from './wip-facets';

export const getCombinedReducers = () => combineReducers({
    amountOfUseItemToUpdate,
    amountOfUseLength,
    amountOfUseModal,
    amountOfUseRequestSearchFilters,
    amountOfUseView,
    auditCount,
    busyCounter,
    closingAccountChanges,
    closingAccountIndex,
    closingAccountLength,
    closingAccountSearchFilters,
    duplicatePinPlateLength,
    duplicatePinPlateSearchFilters,
    duplicatePinPlateView,
    facetFilterText,
    filteredTerritories,
    initialLoad,
    laborRateChanges,
    laborRateChangesLength,
    laborRateChangesSearchFilters,
    machineStatusItemToUpdate,
    machineStatusModal,
    machineStatusSearchFilters,
    machineStatusUpdates,
    pipCodeRequestItemToUpdate,
    pipCodeRequestModal,
    pipCodeRequestSearchFilters,
    pipCodeRequests,
    reportsAccordion,
    searchByDropDown,
    searchQueryString,
    selectedSpaLevels,
    specialAllowanceClaims,
    specialAllowanceClaimsSearchFilters,
    tcsmSettings,
    wipFacets
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/index.js